import type { IconSvgObject } from './types';

const MousePointerOffIcon: IconSvgObject = [
  ["path", { d: "M15.2183 7.78166L21.1821 10.0754C21.6163 10.2424 21.6023 10.8615 21.1609 11.0086L13.7819 13.4683C13.6339 13.5177 13.5177 13.6339 13.4683 13.7819L11.0086 21.1609C10.8615 21.6023 10.2424 21.6163 10.0754 21.1821L7.78166 15.2183M12.3295 6.67055L4.17504 3.53423C3.77402 3.37999 3.37999 3.77402 3.53423 4.17504L6.67055 12.3295", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.5 2.5L2.5 20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MousePointerOffIcon;
